"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.email.placeholder': '输入电子邮件地址',
};
